export const subscriptionPrice = 50;
export const daysFreeTrial = 7;
export const memberMonthlySubscriptionPrice = 50;
export const subscriptionStripePriceLookupKey = 'SUBSCRIPTION_PRICE_INCREASE';
